declare global {
  interface Window {
    nativeAppVersion?: string
    nativeOtaUpdateId?: string | null
    nativeFeatures?: {
      offlineArticles?: boolean
      offlineAudiobooks?: boolean
      offlineBooks?: boolean
      pushNotifications?: boolean
      share?: boolean
    }
    openAudiobook?: (slug: string) => void
    downloadAudiobook?: (slug: string) => void
  }
}

export const MIN_VERSION_NATIVE_AUDIOBOOK = '5.1.0'

export const MIN_VERSION_FORCE_UPDATE_ARVORE = '5.1.9'
export const MIN_VERSION_FORCE_UPDATE_BIBLION = '1.0.9'

export const MIN_VERSION_OPEN_EXTERNAL_ARVORE = '5.1.3'
export const MIN_VERSION_OPEN_EXTERNAL_BIBLION = '1.0.0'

export const compareVersions = (v1: string, v2: string): number => {
  const parts1 = v1.split('.').map(Number)
  const parts2 = v2.split('.').map(Number)

  for (let i = 0; i < Math.max(parts1.length, parts2.length); i++) {
    const p1 = parts1[i] || 0
    const p2 = parts2[i] || 0
    if (p1 > p2) return 1
    if (p1 < p2) return -1
  }
  return 0
}

export const isNativeAppVersionAtLeast = (minVersion: string): boolean => {
  const appVersion = window.nativeAppVersion
  if (!appVersion) return false
  return compareVersions(appVersion, minVersion) >= 0
}

export const isNativeApp = (): boolean => {
  return !!window.nativeAppVersion
}

export const getNativeAppVersion = (): string | undefined => {
  return window.nativeAppVersion
}

export const getNativeOtaUpdateId = (): string | null | undefined => {
  return window.nativeOtaUpdateId
}

export const getNativePlatform = (): 'android' | 'ios' | 'unknown' => {
  const userAgent = window.navigator.userAgent
  if (/android/i.test(userAgent)) return 'android'
  if (/iphone|ipad|ipod/i.test(userAgent)) return 'ios'
  return 'unknown'
}
